import dayjs from 'dayjs';
import React, { useEffect, useMemo, useRef, useState } from 'react'
import storeList from '../../common/storeList';
import NotData from '../../components/NotData';
import Axios from 'axios';
import { Toast } from '../../common/message';
import UserPointExp from '../../common/UserPointExp';

const UserList = () => {

  // 시간 불러오는 부분
  let toDate = new dayjs().format('YYYY-MM-DD');
  let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const toDay = {
    date: toDate,
    time: toTime,
    minusDate,
    plusDate
  }

  const firstCursor = useRef(null);

  const [itemIdx, setItemIdx] = useState(0);
  const basicID = window.sessionStorage.getItem('basicID');
  const basicStore = window.sessionStorage.getItem('basicStore');
    
  // 숫자 천자리 콤마
  function NumberConvert(num)
  {
    var num_parts = num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return num_parts.join(".");
  }

  const [books, setBooks] = useState([]);
  const columns = [
    'No', '담당', '등급', '고객명', '연락처', '성별', 'A/S안내', '메모'
  ];

  const [userNo, setUserNo] = useState(0);

  const [totalUser, setTotalUser] = useState(0);
  const [totalPoint, setTotalPoint] = useState(0);

  const [searchText, setSearchText] = useState('');
  const [searchStore, setSearchStore] = useState('전체');
  const [searchDate, setSearchDate] = useState(toDay.date);

  const [asChack, setASChack] = useState(false);
  const [genderChack, setGenderChack] = useState(false);
  const [userManers, setUserMansers] = useState('');

  const [userName, setUserName] = useState('');
  const [userPhone, setUesrPhone] = useState('');
  const [userStore, setUserStore] = useState('');
  const [userType, setUserType] = useState('');
  const [userMemo, setUserMemo] = useState('');
  const [userAddDate, setUserAddDate] = useState('');

  const [selectStore, setSelectStore] = useState('');
  const [selectType, setSelectType] = useState('');
  const [selectRating, setSelectRating] = useState('');
  const [selectName, setSelectName] = useState('');
  const [selectPhone, setSelectPhone] = useState('');
  const [selectManers, setSelectManers] = useState('');
  const [selectGender, setSelectGender] = useState('');
  const [selectASguid, setSelectASguid] = useState('');
  const [selectPoint, setSelectPoint] = useState('');
  const [selectMemo, setSelectMemo] = useState('');

  // 토탈 유저
  const userTotal = async ()=>{
    await Axios.get(`/api/usermanagement/totaluser`) 
    .then((res)=>{
      setTotalUser(res.data[0].user);
    })
  }
  // 토탈 포인트
  const pointTotal = async ()=>{
    await Axios.get(`/api/usermanagement/totalpoint`) 
    .then((res)=>{
      setTotalPoint(res.data[0].point);
    })
  }

  // 검색 버튼
  const userSearchHandler = async (e)=>{
    e.preventDefault();

    if(!searchText) return alert('검색어를 입력해 주세요');

    await Axios.get(`/api/usermanagement/userlist_search`, {
      params: { searchText }
    })
    .then((res) => {
      if (res.data.length) {
        setBooks(res.data);
      } else {
        setBooks([]);
      }
    });
  }

  // 리스트 불러오기
  const userListLoade = async () => {
    await Axios.get(`/api/usermanagement/userlist`, {
      params: { Store: searchStore, Date: searchDate }
    })
    .then((res) => {
      if (res.data.length) {
        setBooks(res.data);
      } else {
        setBooks([]);
      }
    });
  };

  useEffect(()=>{
    firstCursor.current.focus();
  }, [])

  useMemo(()=>{
    document.title = '고객 관리';

    // setSearchStore('전체');
    // setSearchDate(toDay.date);

    userListLoade();

    userTotal();
    pointTotal();
  }, [searchStore, searchDate])

  // 매장 탭 부분
  const handleStore = (e) => {
    setSearchText("");
    setSearchStore(e.target.value);
  };

  // 날짜 탭 부분
  const handleDate = (e) => {
    setSearchText("");
    setSearchDate(e.target.value);
  };
  
  // 사용자 등록
  const userAddOK = async ()=>{
    await Axios.post(`/api/usermanagement/useradd`, {
      Store: userStore, Type: userType, Rating: userManers, Name: userName,
      Phone: userPhone, Gender: genderChack, ASguid: asChack, Memo: userMemo,
      UserId: window.sessionStorage.getItem('basicID'), Date: toDay.time
    })
    .then((res)=>{
      Toast.fire({ icon: "success", text: `${userName}님 등록 성공` });
      // 포인트 및 기여도 지급
      UserPointExp('고객관리', `${userName} 고객등록`, 5, 5);
    })
  }

  // 사용자 추가시 로그에 기록
  const userLogAdd = async ()=>{
    await Axios.post(`/api/usermanagement/userlogadd`, {
      Log: '추가', i_Store: userStore, i_Type: userType, i_Rating: userManers, 
      i_Name: userName, i_Phone: userPhone, i_Gender: genderChack, i_ASguid: asChack,
      i_Memo: userMemo, MyStore: window.sessionStorage.getItem('basicStore'),
      UserId: window.sessionStorage.getItem('basicID'), Date: toDay.time
    })
    .then((res)=>{
      
    })
  }

  // 사용자 수정 반영
  const userUpdate = async ()=>{
    await Axios.put(`/api/usermanagement/userupdate`, {
      Store: userStore, Type: userType, Rating: userManers, Name: userName,
      Phone: userPhone, Gender: genderChack, ASguid: asChack, Memo: userMemo,
      LastUpdate: toDay.time, UserNo: userNo
    })
    .then((res)=>{
      Toast.fire({ icon: "success", text: `${userName}님 수정 성공` });
      // 포인트 및 기여도 지급
      UserPointExp('고객관리', `${userName} 고객수정`, 2, 2);
    });
  }
  
  // 사용자 수정시 로그에 기록
  const userLogUpdate = async ()=>{
    await Axios.post(`/api/usermanagement/userlogupdate`, {
      Log: '수정', i_Store: selectStore, Store: userStore, i_No: userNo, i_Type: selectType,
      Type: userType, i_Rating: selectManers, Rating: userManers, i_Name: selectName,
      Name: userName, i_Phone: selectPhone, Phone: userPhone, i_Gender: selectGender,
      Gender: genderChack, i_ASguid: selectASguid, ASguid: asChack, i_Memo: selectMemo,
      Memo: userMemo, MyStore: window.sessionStorage.getItem('basicStore'),
      UserId: window.sessionStorage.getItem('basicID'), Date: toDay.time
    })
    .then((res)=>{
      
    })
  }

  // 유저 삭제 함수
  const userDelete = async ()=>{
    await Axios.delete(`/api/usermanagement/userdelete/` + userNo)
    .then((res)=>{
      Toast.fire({ icon: "success", text: `${userName}님 삭제 성공` });
      // 포인트 및 기여도 지급
      UserPointExp('고객관리', `${userName} 고객삭제`, 1, 1);
    });
  }
  
  // 사용자 삭제시 로그에 기록
  const userLogDelete = async ()=>{
    await Axios.post(`/api/usermanagement/userlogdelete`, {
      Log: '삭제', i_Store: userStore, i_Type: userType, i_Rating: userManers, 
      i_Name: userName, i_Phone: userPhone, i_Gender: genderChack, i_ASguid: asChack,
      i_Point: selectPoint, i_Memo: userMemo, MyStore: window.sessionStorage.getItem('basicStore'),
      UserId: window.sessionStorage.getItem('basicID'), Date: toDay.time
    })
    .then((res)=>{
      
    })
  }

  // 유저 추가
  const btnUserAdd = async ()=>{

    if(!userName) return alert('고객님의 이름을 입력해 주세요');
    if(!userPhone) return alert(`${userName}님의 연락처를 입력해 주세요`);
    if(!Number(userPhone)) return alert(`연락처는 숫자만 입력해 주세요`);
    if(!userManers) return alert('사용자의 매너를 지정해 주세요');
    if(!asChack) return alert(`${userName}님의 A/S 안내 여부를 체크해 주세요`);
    if(!genderChack) return alert(`${userName}님의 성별을 체크해 주세요`);
    if(!userStore) return alert(`${userName}님의 담당 매장을 선택해 주세요`);
    if(!userType) return alert(`${userName}님의 등급을 선택해 주세요`);
    if(!userMemo) return alert(`${userName}님이 구매하신 제품들을 메모로 남겨주세요`);

    // 사용자 휴대폰 번호 중복확인
    await Axios.get(`/api/usermanagement/userphonechack`, {
      params: { Phone: userPhone }
    })
    .then((res)=>{
      if(res.data.value){ // 휴대폰 중복 체크

        if(!window.confirm(`${userName}님을 등록하시겠습니까?`)) return;
  
        // 휴대폰 번호가 중복이 아닐 때 등록
        userAddOK();
        userLogAdd();
        userTotal();
        pointTotal();

        // 처리시 복사 데이터에 즉시 반영
        setBooks(()=>{
          const addData = {
            store: userStore, type: userType, rating: userManers,
            name: userName, phone: userPhone, gender: genderChack,
            asguid: asChack, point: 0, memo: userMemo, id: basicID,
            date: toDay.time
          };
          const copyTB = [...books, addData];
          return copyTB;
        });
      } else {
        return alert(`해당 번호는 이미 고객님으로 등록되어 있습니다.`);
      }
    })
    reset();
  };

  // 유저 수정
  const btnUserUpdate = async ()=>{

    if(!userNo) return alert('수정할 고객을 선택해 주세요.');
    if(!window.confirm('해당 유저를 수정 하시겠습니까?')) return;

    userLogUpdate();
    userUpdate();

    // 수정된 값으로 교체
    setBooks(()=>{
      const copy = [...books];
      copy[itemIdx].store = userStore;
      copy[itemIdx].type = userType;
      copy[itemIdx].rating = userManers;
      copy[itemIdx].name = userName;
      copy[itemIdx].phone = userPhone;
      copy[itemIdx].gender = genderChack;
      copy[itemIdx].asguid = asChack;
      copy[itemIdx].memo = userMemo;
      return copy;
    });
    reset();
  }

  // 유저 삭제
  const btnUserDelete = async ()=>{

    if(!userNo) return alert('삭제할 고객을 선택해 주세요.');
    if(!window.confirm('해당 유저를 삭제하시겠습니까?')) return;

    userLogDelete();
    userDelete();

    userTotal();
    pointTotal();

    // 데이터 테이블에 안 보이게 처리
    setBooks(books.filter(item => item.no !== userNo));

    reset();
  }

  // 셀렉트 테스트
  const [selectedRow, setSelectedRow] = useState(-1);

  // 리셋 함수
  const reset = ()=>{
    setSearchText('')
    setSearchStore('전체');
    
    setUserStore('선택');
    setUserType('선택');
    setUserName('');
    setUesrPhone('');
    setUserMansers('');
    setASChack('');
    setGenderChack('');
    setUserMemo('');
    setUserAddDate('');


    setSelectedRow(-1);
  }
    
  return (
    <div className='grid grid-cols-1 md:flex md:justify-between text-sm p-3 md:h-[calc(100vh-4rem)] gap-1'>

    {/* 메인 */}
    <div className='relative border-[1px] border-gray-500 w-full md:w-3/4 md:h-full h-[60vh] overflow-y-auto'>
      <table id='testTable' className='w-full'>
        <thead className='bg-[#1E1E1E]/90 whitespace-nowrap text-center sticky top-0 z-10'>
          <tr className='border-b-[1px] border-gray-500'>
            {columns.map((column) => (
              <th className='p-3' key={column}>{column}</th>
            ))}
          </tr>
        </thead>
        <tbody className='text-center'>
          {
            books.length ?
            books.map((book, idx) => (
              <tr className=
              {`
                duration-150 decoration-yellow-600 whitespace-nowrap active:scale-[0.98] active:opacity-80
                ${selectedRow === idx ? 'bg-[#1E1E1E] font-bold underline decoration-[3px]' : 'even:bg-[#3E3E3E]'}
              `}
              key={idx} onClick={(e)=>{
                setSelectedRow(idx);
                setItemIdx(idx);
                setUserNo(book.no);

                setUserName(book.name);
                setUesrPhone(book.phone);
                setUserStore(book.store);
                setUserType(book.type);
                setUserMemo(book.memo);
                setUserAddDate(book.date);

                setUserMansers(`${book.rating}`);

                setASChack(book.asguid);
                setGenderChack(book.gender);

                setSelectStore(book.store);
                setSelectType(book.type)
                setSelectRating(book.type);
                setSelectName(book.name);
                setSelectPhone(book.phone);
                setSelectGender(book.gender);
                setSelectManers(book.rating);
                setSelectASguid(book.asguid);
                setSelectPoint(book.point);
                setSelectMemo(book.memo);
              }}>
                <td className='p-2.5'>{idx + 1}</td>
                <td className='p-2.5 border-x-[1px] border-gray-500'>{book.store}</td>
                <td className='p-2.5 border-x-[1px] border-gray-500'>{book.type}</td>
                <td className='p-2.5 border-x-[1px] border-gray-500'>{book.name}</td>
                <td className='p-2.5 border-x-[1px] border-gray-500'>{book.phone}</td>
                <td className='p-2.5 border-x-[1px] border-gray-500'>{book.gender}</td>
                <td className='p-2.5 border-x-[1px] border-gray-500'>{book.asguid}</td>
                {/* <td className='p-2.5'>{book.point}</td> */}
                <td className='p-2.5 max-w-[300px]'>{`
                  ${(!book.memo && '메모 없음') || (book.memo.length > 30 ? book.memo.substr(0, 30) + ' ...' : book.memo)}
                `}</td>
              </tr>
            ))
            :
            <tr className='relative'>
              <td className='absolute w-full top-[30vh] left-auto'>
                <NotData/>
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    {/* 사이드 */}
    <div className='md:w-1/4 w-full md:overflow-y-auto bg-[#424242] border-[1px] border-gray-500'>
      <div className='bg-[#0067BD] py-2 text-center'>
        <p className='text-left pl-3'>
          ※ 고객 등록 및 관리
        </p>
      </div>

      <div className='p-3 flex flex-col gap-2'>

      {/* 고객 및 포인트 */}
      <div className='flex flex-col justify-center items-center text-xs gap-1 bg-[#2E2E2E] rounded-md p-3'>
        <p className='text-sm'>등록된 고객님 : {NumberConvert(totalUser)} 명</p>
        <p className='text-sm'>발행된 포인트 : {NumberConvert(totalPoint)} 원</p>
      </div>

      {/* 이름, 연락처 검색 */}
      <form className='w-full flex gap-2' autoComplete='off'>
        <input ref={firstCursor} id='searchInput' className='bg-[#2E2E2E] h-12 w-full p-2 rounded-md text-center outline-none border-[1px] border-gray-400' type='search' placeholder='이름 or 연락처' value={searchText} onChange={(e)=>setSearchText(e.target.value)}/>
        <input className='bg-blue-600 px-3 py-2 h-12 rounded-sm w-[30%] cursor-pointer' type='submit' value='검색' onClick={userSearchHandler}/>
      </form>            

      {/* 고객 검색 */}
      <form className='grid grid-cols-2 gap-2' autoComplete='off'>
        <div className='w-full'>
          <p>매장 조회</p>
          <select id='storeInput' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md cursor-pointer outline-none border-[1px] border-gray-400' value={searchStore} onChange={handleStore}>
            {storeList.storeAll.map((item) => (
              <option value={item} key={item}>
                {item}
              </option>
            ))}
          </select>
        </div>
        <div className='w-full'>
          <p>날짜 조회</p>
          <input id='dateInput' type='date' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400' value={searchDate} onChange={handleDate} />
        </div>
      </form>

      {/* 언더라인 */}
      <div className='border-b-[1px] border-gray-400 py-1'></div>

    {/* 매장 및 날짜 조회 */}
    <div className='flex gap-2'>
      <div className='w-full'>
        <p>담당 매장</p>
        <select className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md cursor-pointer outline-none border-[1px] border-gray-400' value={userStore} onChange={(e)=>setUserStore(e.target.value)}>
          <option value="">선택</option>
          <option>탄방점</option>
          <option>둔산점</option>
          <option>자양점</option>
          <option>충대점</option>
        </select>
      </div>
      <div className='w-full'>
        <p>고객 등급</p>
        <select className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md cursor-pointer outline-none border-[1px] border-gray-400' value={userType} onChange={(e)=>setUserType(e.target.value)}>
          <option value="">선택</option>
          <option>VIP</option>
          <option>우수</option>
          <option>일반</option>
        </select>
      </div>
    </div>
    
      {/* 이름 */}
      <div className='grid gap-3'>
        <p className='whitespace-nowrap'>이름</p>
        <input placeholder='이름을 입력하세요' className='bg-[#2E2E2E] w-full h-12 rounded-md text-center border-[1px] border-gray-300' type='text' value={userName} onChange={(e)=>setUserName(e.target.value)}/>
      </div>

      {/* 연락처 */}
      <div className='grid gap-3'>
        <p className='whitespace-nowrap'>연락처</p>
        <input placeholder='연락처를 입력하세요' className='bg-[#2E2E2E] w-full h-12 rounded-md text-center border-[1px] border-gray-300' type='text' value={userPhone} onChange={(e)=>setUesrPhone(e.target.value)}/>
      </div>

      {/* 매너 */}
      <div className='grid grid-flow-row grap-3'>
        <p className='whitespace-nowrap'>매너</p>
        <div className='py-3 overflow-x-auto'>
          <ul className="flex w-full gap-1">
            <li className='w-full'>
              <input type="checkbox" id="1" value='1' className="hidden peer" checked={userManers === '1' ? true : false } onChange={(e)=>setUserMansers(e.target.value)}/>
              <label htmlFor="1" className="inline-flex duration-150 items-center justify-center rounded-md border-2 w-full px-3 py-2 text-gray-300 cursor-pointer hover:text-gray-300 border-gray-700 peer-checked:border-blue-500 peer-checked:text-gray-100 bg-gray-800 hover:bg-gray-700">                           
                <div className="flex justify-center items-center">
                  <div className="w-full whitespace-nowrap text-base">진상</div>
                </div>
              </label>
            </li>
            <li className='w-full'>
              <input type="checkbox" id="2" value="2" className="hidden peer" checked={userManers === '2' ? true : false } onChange={(e)=>setUserMansers(e.target.value)}/>
              <label htmlFor="2" className="inline-flex duration-150 items-center justify-center rounded-md border-2 w-full px-3 py-2 text-gray-300 cursor-pointer hover:text-gray-300 border-gray-700 peer-checked:border-blue-500 peer-checked:text-gray-100 bg-gray-800 hover:bg-gray-700">
                <div className="flex justify-center items-center">
                  <div className="w-full whitespace-nowrap text-base">주의</div>
                </div>
              </label>
            </li>
            <li className='w-full'>
              <input type="checkbox" id="3" value="3" className="hidden peer" checked={userManers === '3' ? true : false } onChange={(e)=>setUserMansers(e.target.value)}/>
              <label htmlFor="3" className="inline-flex duration-150 items-center justify-center rounded-md border-2 w-full px-3 py-2 text-gray-300 cursor-pointer hover:text-gray-300 border-gray-700 peer-checked:border-blue-500 peer-checked:text-gray-100 bg-gray-800 hover:bg-gray-700">
                <div className="flex justify-center items-center">
                  <div className="w-full whitespace-nowrap text-base">보통</div>
                </div>
              </label>
            </li>
            <li className='w-full'>
              <input type="checkbox" id="4" value="4" className="hidden peer" checked={userManers === '4' ? true : false } onChange={(e)=>setUserMansers(e.target.value)}/>
              <label htmlFor="4" className="inline-flex duration-150 items-center justify-center rounded-md border-2 w-full px-3 py-2 text-gray-300 cursor-pointer hover:text-gray-300 border-gray-700 peer-checked:border-blue-500 peer-checked:text-gray-100 bg-gray-800 hover:bg-gray-700">
                <div className="flex justify-center items-center">
                  <div className="w-full whitespace-nowrap text-base">좋음</div>
                </div>
              </label>
            </li>
            <li className='w-full'>
              <input type="checkbox" id="5" value="5" className="hidden peer" checked={userManers === '5' ? true : false } onChange={(e)=>setUserMansers(e.target.value)}/>
              <label htmlFor="5" className="inline-flex duration-150 items-center justify-center rounded-md border-2 w-full px-3 py-2 text-gray-300 cursor-pointer hover:text-gray-300 border-gray-700 peer-checked:border-blue-500 peer-checked:text-gray-100 bg-gray-800 hover:bg-gray-700">
                <div className="flex justify-center items-center">
                  <div className="w-full whitespace-nowrap text-base">천사</div>
                </div>
              </label>
            </li>
          </ul>
        </div>
      </div>

      {/* A/S안내 및 성별 */}
      <div className='flex justify-center items-center gap-2'>

      {/* A/S 안내 */}
      <div className='flex flex-col gap-2 rounded-md w-full'>
        <div className=''>
          <p className=''>A/S 안내</p>
        </div>
        <div className='flex justify-center items-center'>
          <ul className="grid w-full gap-1 md:grid-cols-2">
            <li>
              <input type="checkbox" id="yes" value="Yes" className="hidden peer" checked={asChack === 'Yes' ? true : false } onChange={(e)=>{setASChack(e.target.value)}}/>
              <label htmlFor="yes" className="inline-flex duration-150 items-center justify-center w-full px-5 py-2 rounded-lg cursor-pointer hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-400 bg-gray-800 hover:bg-gray-700">                           
                <div className="flex justify-center items-center">
                  <div className="w-full whitespace-nowrap text-base">Yes</div>
                </div>
              </label>
            </li>
            <li>
              <input type="checkbox" id="no" value="No" className="hidden peer" checked={asChack === 'No' ? true : false } onChange={(e)=>setASChack(e.target.value)}/>
              <label htmlFor="no" className="inline-flex duration-150 items-center justify-center w-full px-5 py-2 rounded-lg cursor-pointer hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-400 bg-gray-800 hover:bg-gray-700">
                <div className="flex justify-center items-center">
                  <div className="w-full whitespace-nowrap text-base">No</div>
                </div>
              </label>
            </li>
          </ul>
        </div>
      </div>

      {/* 성별 */}
      <div className='flex flex-col gap-2 rounded-md w-full'>
        <div className='flex justify-between'>
          <p className=''>성별</p>
        </div>
        <div className='flex justify-center items-center'>
          <ul className="grid w-full gap-1 md:grid-cols-2">
            <li>
              <input type="checkbox" id="man" value="남자" className="hidden peer" checked={genderChack === '남자' ? true : false } onChange={(e)=>setGenderChack(e.target.value)}/>
              <label htmlFor="man" className="inline-flex duration-150 items-center justify-center w-full px-5 py-2 rounded-lg cursor-pointer hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-400 bg-gray-800 hover:bg-gray-700">  
                <div className="flex justify-center items-center">
                  <div className="w-full whitespace-nowrap text-base">남자</div>
                </div>
              </label>
            </li>
            <li>
              <input type="checkbox" id="woman" value="여자" className="hidden peer" checked={genderChack === '여자' ? true : false } onChange={(e)=>setGenderChack(e.target.value)}/>
              <label htmlFor="woman" className="inline-flex duration-150 items-center justify-center w-full px-5 py-2 rounded-lg cursor-pointer hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-400 bg-gray-800 hover:bg-gray-700">
                <div className="flex justify-center items-center">
                  <div className="w-full whitespace-nowrap text-base">여자</div>
                </div>
              </label>
            </li>
          </ul>
        </div>
      </div>
    </div>

    <div className='flex flex-col gap-2 w-full'>
      <div className='flex justify-between'>
        <p className=''>고객 메모</p>
        <button className='px-2 text-yellow-400' onClick={()=>alert('텍스트박스 우측 하단을 드래그시 창을 늘리거나 축소 할 수 있습니다.')}>
          펼치기
        </button>
      </div>
      <div className='flex flex-col justify-center items-center'>
        <textarea placeholder='고객에 대한 메모를 입력하세요' className='w-full text-center h-20 border-[1px] outline-none border-gray-300 bg-[#2E2E2E] rounded-md ml-5 mr-5 p-3' type='text' value={userMemo} onChange={(e)=>{
          setUserMemo(e.target.value);
        }} />
      </div>
    </div>

    {/* 고객 등록 날짜 */}
    <div id='priceText' className='flex flex-col justify-center gap-3'>
      <p>고객 등록 날짜</p>
      <input placeholder='고객을 선택하세요' className='bg-[#2E2E2E] h-12 rounded-md text-center' disabled type='text' value={userAddDate} />
    </div>
    
    {/* 언더라인 */}
    <div className='border-b-[1px] border-gray-400 py-1'></div>

    {/* 주문 요청 */}
    <div className='flex flex-col gap-2 pt-2'>
      <div>
        <button className='bg-[#2E2E2E] h-[40px] w-[100%] rounded-md text-center border-[1px] border-[#1F8BE2]' onClick={btnUserAdd} >
          고객 등록
        </button>
      </div>
      <div className='grid grid-cols-2 gap-2'>
        <button className='bg-[#2E2E2E] h-10 rounded-md text-center border-[1px] border-yellow-300' onClick={btnUserUpdate} >
          수정
        </button>
        <button className='bg-[#2E2E2E] h-10 rounded-md text-center border-[1px] border-yellow-300' onClick={btnUserDelete} >
          삭제
        </button>
      </div>
    </div>

        </div>
    </div>

    </div>
  )
}

export default UserList